import script from "./Register.vue?vue&type=script&setup=true&lang=js"
export * from "./Register.vue?vue&type=script&setup=true&lang=js"

import "./Register.vue?vue&type=style&index=0&id=fc7314b2&scoped=true&lang=less"

import exportComponent from "C:\\Users\\Florian\\Desktop\\all-in-one\\all-in-one-fitness\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc7314b2"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QBtn});
